import { useEffect, useContext, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";

const PhGetCertified = (props) => {

  return (
    <>
      <main class="container mx-auto px-6 py-10">
        <h1 class="text-2xl font-bold text-gray-800 mb-6">Get Certified</h1>

        <div class="text-right">
            <a href={`${process.env.PUBLIC_URL}/photographer-dashboard`} class="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90 inline-block mb-4">
                <i class="fas fa-arrow-left mr-2"></i>Back to Dashboard
            </a>
        </div>

        {/* <!-- Play box (full width) --> */}
        <div id="playerArea" class="play-box w-full" role="button" aria-pressed="false" tabindex="0" data-scorm-src="scorm/index.html">
            <div class="text-center">
                <div class="inline-block">
                    <div class="play-icon" aria-hidden="true">
                        <a href="hr-certification-complete.html"><i class="fas fa-play"></i></a>
                    </div>
                </div>
                <div class="play-label">Click to start the certification</div>
            </div>
        </div>

        <div class="mt-4 notice">Place your SCORM package's launch file at <code>scorm/index.html</code> (relative to this page) or update the <code>data-scorm-src</code> attribute on the container to point to your SCORM launch URL.</div>

        <div id="scormContainer" class="mt-6" aria-live="polite"></div>
    </main>
    </>
  );
};

export default PhGetCertified;
